var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FETCH_CHAT_DATA_SUCCESS, FETCH_CHAT_DATA, UPDATE_CHAT_DATA, UPDATE_PERMISSIONS, UPDATE_SCROLL, FETCH_CHAT_DATA_REJECTED, RESET_STATE, UPDATE_COMMENT_START, UPDATE_COMMENT_END, FETCH_MORE_CHAT_DATA, FETCH_MORE_CHAT_DATA_SUCCESS, FETCH_MORE_CHAT_DATA_REJECTED, FETCH_INIT_CHAT_DATA, FETCH_INIT_CHAT_DATA_SUCCESS, FETCH_INIT_CHAT_DATA_REJECTED, FETCH_MORE_COMMENTS, FETCH_MORE_COMMENTS_SUCCESS, FETCH_MORE_COMMENTS_REJECT, UPDATE_COMMENT_STATUS } from '../actions/chatActions';
import { INITIAL_REQUEST_FILTER } from '../components/desktopApp/comments/const/const';
var initialState = {
    messages: {},
    posts: [],
    loading: false,
    editing: false,
    imageMode: false,
    answerId: null,
    creatingId: null,
    scrollId: null,
    isScrolling: false,
    filter: INITIAL_REQUEST_FILTER,
    prevFilter: {},
    permissions: {
        entityType: 'post',
        longreadId: '',
        isBlackList: false,
        isWhiteList: false,
        closedStatus: 1,
        channelOwner: {},
        isPrivateChat: false,
        // entityId: team?.teamId,
        closedMsg: [],
        isChatClosed: false,
    },
    postsFetching: false
};
export function chatReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case FETCH_INIT_CHAT_DATA:
            return __assign(__assign({}, state), { loading: true });
        case FETCH_INIT_CHAT_DATA_SUCCESS:
            return __assign(__assign(__assign({}, state), action.payload), { loading: false });
        case FETCH_INIT_CHAT_DATA_REJECTED:
            return __assign(__assign(__assign({}, state), action.payload), { loading: false });
        case FETCH_CHAT_DATA:
            return __assign(__assign({}, state), action.payload);
        case FETCH_CHAT_DATA_SUCCESS:
            return __assign(__assign(__assign({}, state), action.payload), { loading: false });
        case FETCH_CHAT_DATA_REJECTED:
            return __assign(__assign(__assign({}, state), action.payload), { loading: false });
        case FETCH_MORE_CHAT_DATA:
            return __assign(__assign({}, state), { loading: true, postsFetching: true });
        case FETCH_MORE_CHAT_DATA_SUCCESS:
            return __assign(__assign(__assign({}, state), action.payload), { loading: false });
        case FETCH_MORE_CHAT_DATA_REJECTED:
            return __assign(__assign(__assign({}, state), action.payload), { loading: false });
        case FETCH_MORE_COMMENTS:
            return __assign({}, state);
        case FETCH_MORE_COMMENTS_SUCCESS:
            return __assign(__assign({}, state), action.payload);
        case FETCH_MORE_COMMENTS_REJECT:
            return __assign(__assign({}, state), action.payload);
        case UPDATE_CHAT_DATA:
            return __assign(__assign({}, state), action.payload);
        case UPDATE_PERMISSIONS:
            return __assign(__assign({}, state), { permissions: action.payload });
        case UPDATE_SCROLL:
            return __assign(__assign({}, state), { isScrolling: action.payload });
        case UPDATE_COMMENT_START:
            return __assign(__assign({}, state), action.payload);
        case UPDATE_COMMENT_END:
            return __assign(__assign(__assign({}, state), action.payload), { creatingId: null });
        case UPDATE_COMMENT_STATUS:
            return __assign(__assign({}, state), action.payload);
        case RESET_STATE:
            return __assign(__assign({}, state), { posts: [], messages: {}, loading: true });
        default:
            return state;
    }
}
;
export function getChat(state) {
    return state === null || state === void 0 ? void 0 : state.chat;
}
//# sourceMappingURL=chatReducer.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FETCH_CHAT_DATA_SUCCESS, FETCH_CHAT_DATA, UPDATE_CHAT_DATA, UPDATE_PERMISSIONS, UPDATE_SCROLL, FETCH_CHAT_DATA_REJECTED, RESET_STATE, UPDATE_COMMENT_START, UPDATE_COMMENT_END, FETCH_MORE_CHAT_DATA, FETCH_MORE_CHAT_DATA_SUCCESS, FETCH_MORE_CHAT_DATA_REJECTED, FETCH_INIT_CHAT_DATA, FETCH_INIT_CHAT_DATA_SUCCESS, FETCH_INIT_CHAT_DATA_REJECTED, FETCH_MORE_COMMENTS, FETCH_MORE_COMMENTS_SUCCESS, FETCH_MORE_COMMENTS_REJECT, UPDATE_COMMENT_STATUS } from '../actions/chatActions';
import { INITIAL_REQUEST_FILTER } from '../components/desktopApp/comments/const/const';
var initialState = {
    messages: {},
    posts: [],
    loading: false,
    editing: false,
    imageMode: false,
    answerId: null,
    creatingId: null,
    scrollId: null,
    isScrolling: false,
    filter: INITIAL_REQUEST_FILTER,
    prevFilter: {},
    permissions: {
        entityType: 'post',
        longreadId: '',
        isBlackList: false,
        isWhiteList: false,
        closedStatus: 1,
        channelOwner: {},
        isPrivateChat: false,
        // entityId: team?.teamId,
        closedMsg: [],
        isChatClosed: false,
    },
    postsFetching: false
};
export function chatReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case FETCH_INIT_CHAT_DATA:
            return __assign(__assign({}, state), { loading: true });
        case FETCH_INIT_CHAT_DATA_SUCCESS:
            return __assign(__assign(__assign({}, state), action.payload), { loading: false });
        case FETCH_INIT_CHAT_DATA_REJECTED:
            return __assign(__assign(__assign({}, state), action.payload), { loading: false });
        case FETCH_CHAT_DATA:
            return __assign(__assign({}, state), action.payload);
        case FETCH_CHAT_DATA_SUCCESS:
            return __assign(__assign(__assign({}, state), action.payload), { loading: false });
        case FETCH_CHAT_DATA_REJECTED:
            return __assign(__assign(__assign({}, state), action.payload), { loading: false });
        case FETCH_MORE_CHAT_DATA:
            return __assign(__assign({}, state), { loading: true, postsFetching: true });
        case FETCH_MORE_CHAT_DATA_SUCCESS:
            return __assign(__assign(__assign({}, state), action.payload), { loading: false });
        case FETCH_MORE_CHAT_DATA_REJECTED:
            return __assign(__assign(__assign({}, state), action.payload), { loading: false });
        case FETCH_MORE_COMMENTS:
            return __assign({}, state);
        case FETCH_MORE_COMMENTS_SUCCESS:
            return __assign(__assign({}, state), action.payload);
        case FETCH_MORE_COMMENTS_REJECT:
            return __assign(__assign({}, state), action.payload);
        case UPDATE_CHAT_DATA:
            return __assign(__assign({}, state), action.payload);
        case UPDATE_PERMISSIONS:
            return __assign(__assign({}, state), { permissions: action.payload });
        case UPDATE_SCROLL:
            return __assign(__assign({}, state), { isScrolling: action.payload });
        case UPDATE_COMMENT_START:
            return __assign(__assign({}, state), action.payload);
        case UPDATE_COMMENT_END:
            return __assign(__assign(__assign({}, state), action.payload), { creatingId: null });
        case UPDATE_COMMENT_STATUS:
            return __assign(__assign({}, state), action.payload);
        case RESET_STATE:
            return __assign(__assign({}, state), { posts: [], messages: {}, loading: true });
        default:
            return state;
    }
}
;
export function getChat(state) {
    return state === null || state === void 0 ? void 0 : state.chat;
}
//# sourceMappingURL=chatReducer.js.map